import { ComponentPropsWithoutRef, createElement } from "react";
import { AddendumsContextProvider } from "../scenes/note-fill-in/contexts/AddendumsContext";
import { NOTES_TYPES, TNotesType } from "../types";

type Props = Omit<
  ComponentPropsWithoutRef<typeof AddendumsContextProvider>,
  "children"
>;

/**
 * render component w/ addendum data provider
 */
const withAddendums = (
  type: TNotesType,
  Wrapped: JSX.Element,
  addendumsContextProviderProps: Props,
) =>
  type === NOTES_TYPES.note ? (
    <AddendumsContextProvider {...addendumsContextProviderProps}>
      {createElement(Wrapped.type, Wrapped.props)}
    </AddendumsContextProvider>
  ) : (
    createElement(Wrapped.type, Wrapped.props)
  );

export default withAddendums;
